// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NOTE: many of these constants have been duplicated in cssConstants.tsx */
/* Colours for Grid*/
/* Colours for Check statuses*/
/* Other colours */
/* black/grays/whites */
/* Colours for Data capture page*/
/* borders */
/* Dimensions*/
/* z-indexes */
/* Media queries */
/* Font Size */
/* Font Family */
/* Font Style */
.paragraph {
  font-size: 15px;
}
.paragraph img {
  display: inline-block;
  margin-left: 15px;
  vertical-align: bottom;
}
.paragraph img + p.paragraphText {
  display: inline-block;
  margin-left: 5px;
}
@media (max-width: 845px) {
  .paragraph.warning {
    margin-top: -16px;
  }
  .paragraph img {
    margin-left: 0;
  }
  .paragraph img + p.paragraphText {
    margin-left: 25px;
    margin-top: -18px;
  }
}
.paragraph .paragraphText {
  font-size: 15px;
  line-height: 20px;
  color: #262626;
  margin-bottom: 20px;
}
.paragraph .paragraphText.warning {
  color: #c23a00;
}
.paragraph .paragraphText.accessNIContent {
  color: #061c3f;
  font-weight: normal;
}
.paragraph .paragraphText:last-child {
  margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/common/dataCapture/Paragraph.less"],"names":[],"mappings":"AAAA,2EAA2E;AAC3E,oBAAoB;AACpB,8BAA8B;AAC9B,kBAAkB;AAClB,uBAAuB;AACvB,iCAAiC;AACjC,YAAY;AACZ,cAAc;AACd,cAAc;AACd,kBAAkB;AAClB,cAAc;AACd,gBAAgB;AAChB,eAAe;AAVf;EACC,eAAA;AAYD;AAbA;EAIE,qBAAA;EACA,iBAAA;EACA,sBAAA;AAYF;AAlBA;EASE,qBAAA;EACA,gBAAA;AAYF;AATC;EACC;IACC,iBAAA;EAWD;EAbD;IAKE,cAAA;EAWD;EAhBD;IAQE,iBAAA;IACA,iBAAA;EAWD;AACF;AAlCA;EA2BE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAUF;AARE;EACC,cAAA;AAUH;AAPE;EACC,cAAA;EACA,mBAAA;AASH;AA/CA;EA2CE,gBAAA;AAOF","sourcesContent":["@import '../../constants.less';\n\n.paragraph {\n\tfont-size: 15px;\n\n\timg {\n\t\tdisplay: inline-block;\n\t\tmargin-left: 15px;\n\t\tvertical-align: bottom;\n\t}\n\timg + p.paragraphText {\n\t\tdisplay: inline-block;\n\t\tmargin-left: 5px;\n\t}\n\n\t@media (max-width: @dataCaptureOneColumnFieldsPageMaxWidth) {\n\t\t&.warning {\n\t\t\tmargin-top: -16px;\n\t\t}\n\t\timg {\n\t\t\tmargin-left: 0;\n\t\t}\n\t\timg + p.paragraphText {\n\t\t\tmargin-left: 25px;\n\t\t\tmargin-top: -18px;\n\t\t}\n\t}\n\n\t.paragraphText {\n\t\tfont-size: 15px;\n\t\tline-height: 20px;\n\t\tcolor: @grey26;\n\t\tmargin-bottom: 20px;\n\n\t\t&.warning {\n\t\t\tcolor: @statusOrange;\n\t\t}\n\n\t\t&.accessNIContent {\n\t\t\tcolor: #061c3f;\n\t\t\tfont-weight: normal;\n\t\t}\n\t}\n\n\t.paragraphText:last-child {\n\t\tmargin-bottom: 0;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
